import React from 'react';
import { Box } from '@mui/material';
import { Tiers } from '@europrocurement/l2d-modules/providers/TiersProvider';
import { PrescriberInfoCard } from '../PrescriberInfoCard';
import { PrescriberContactCard } from '../PrescriberContactCard';

export type PrescriberResumeProps = {
    prescriber: Tiers;
};

const PrescriberResume: React.FunctionComponent<PrescriberResumeProps> = function ({ prescriber }) {
    return (
        <Box sx={{ display: 'flex', gap: '24px', alignItems: 'flex-start' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexGrow: '0',
                    flexShrink: '0',
                    flexBasis: '33%',
                    flexDirection: 'column',
                    rowGap: '1em',
                }}
            >
                <PrescriberInfoCard
                    title="Informations du prescripteur"
                    tiers={prescriber}
                />
                <PrescriberContactCard tiers={prescriber} />
            </Box>
            <Box sx={{ display: 'flex', flexGrow: '1', flexShrink: '1' }} />
        </Box>
    );
};

export default PrescriberResume;
